// extracted by mini-css-extract-plugin
export default {"idLogin":"index_idLogin__YuVff","forget":"index_forget__Ehpg6","formItem":"index_formItem__xHtgl","tips":"index_tips__aLODa"};